// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"753298ce","316":"17a310a1","488":"37cec2e0"}[chunkId] + ".chunk.js";
};